/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Divider, FormControl, FormControlLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, Skeleton, TextField, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { SyntheticEvent, useEffect, useReducer, useState } from 'react'
import Card from '../../../utils/Card'
import { CARD_SHADOW } from '../../../utils/Constants'
import CardHeader from '../../../utils/CardHeader'
import ReactQuill from 'react-quill'
import { useDispatch, useSelector } from 'react-redux'
import { OBG_NOTES, TRIMESTER_NOTES } from '../../../../../../shared/constants'
  
  const EditorModules = {
    toolbar: [
      ["bold", "italic", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
    clipboard: {
      matchVisual: false,
    },
  };
  
  const initState = {
    trimesterNumber:'',
    fhr:'',
    bloodGroup:'',
    vaccinations:'',
    vaccinationsComments:'',
    investigation:'',
    investigationComments:'',
    details: '',
    vaccinationsOptions:[],
    investigationOptions:[],
  }

const TrimesterNotes = (props:any) => {

  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const isFocused: boolean = props.isFocused || false;
  const sectionData = props?.sectionData?.[0];

  const [state,setState] = useReducer((state:any,action:any)=>{
    return {
        ...state,
        ...action
    }
  },initState)

  const { setTabData } = props;
//   const {
//     prescription: { instantRxData },
//   } = useSelector((state: any) => state.prescription);

  const SaveTemplateStyle = {
    position: isMobileScreen ? "absolute" : "none",
    top: "144px",
    left: "0px",
    zIndex: 1,
    height: "0px",
    width:"100%"
  };

  const AddMiniTemplateStyle = {
    position: isMobileScreen ? "absolute" : "none",
    top: "144px",
    right: "16px",
    zIndex: 1,
    height: "0px",
  };


  useEffect(()=>{
    console.log("state",state)
  },[state])

  useEffect(() => {
    if (sectionData) {
        const data = sectionData?.value;
       
        const trimesterNumber:any = data?.find((elem:any)=>elem?.name === 'Trimester number')
        const fhr = data?.find((elem:any)=>elem?.name === 'FHR')
        const bloodGroup = data?.find((elem:any)=>elem?.name === 'Blood group')
        const vaccinations = data?.find((elem:any)=>elem?.name === 'Vaccination')
        const vaccinationsComments = data?.find((elem:any)=>elem?.name === 'vaccination_comment')
        const investigation = data?.find((elem:any)=>elem?.name === 'Investigation')
        const investigationComments = data?.find((elem:any)=>elem?.name === 'investigation_comment')
        const comment = data?.find((elem:any)=>elem?.name === 'comment')

        const master = sectionData?.master?.values
        const vaccinationsOptions = master?.find((elem:any)=>elem?.name === 'Vaccination')?.value
        const investigationOptions = master?.find((elem:any)=>elem?.name === 'Investigation')?.value
        
        setState({
            trimesterNumber:trimesterNumber ? trimesterNumber?.value : '',
            fhr:fhr ? fhr?.value : '',
            bloodGroup:bloodGroup ? bloodGroup?.value : '',
            vaccinations:vaccinations ? vaccinations?.value : '',
            vaccinationsComments:vaccinationsComments ? vaccinationsComments?.value : '',
            investigation:investigation ? investigation?.value : '',
            investigationComments:investigationComments ? investigationComments?.value : '',
            details: comment ? comment?.value : '',
            vaccinationsOptions:vaccinationsOptions ? vaccinationsOptions : [],
            investigationOptions:investigationOptions ? investigationOptions : [],
        })
      setLoading(false);
    }
  }, [sectionData]);

  const resetTabData = ()=>{
    setTabData((prev: any) => {
        return prev.map((section: any) => {
          if (section.view_type === OBG_NOTES) {
            return {
              ...section,
              rows: section.rows.map((row: any) => {
                if (row.view_type === TRIMESTER_NOTES) {
                  return {
                    ...row,
                    value: row?.value?.map((val: any) => {
                      return {...val,value:''};
                    }),
                  };
                }
                return row;
              }),
            };
          }
          return section;
        });
      });
  }


  const renderHeaderButtons = ()=>{

    const buttons = [
        {
            name:'Delete',
            icon:'icon_delete_rx.svg',
            onClick:()=>{
                setState({initState})
                resetTabData();
                props?.setShowHistory({
                    ...props?.showHistory,
                    ["Trimester notes"]: false,
                })
            }
        },
    ]

    

    return (
        <>
            {buttons.map((elem,index)=>{
                return (
                    <button
                        key={elem.name}
                        style={{
                            outline: "none",
                            background: "none",
                            backgroundColor:theme.palette.primary.light,
                            padding: 8,
                            // marginRight: index !== imgs.length - 1 ? 16 : 0,
                            border: 0,
                            borderRadius:'50%',
                            display:'flex',
                            justifyContent:'center',
                            alignItems:'center'
                        }}
                    >
                        <Tooltip
                            title={elem.name}
                        >
                            <img
                                onClick={elem.onClick}
                                src={`/images/${elem.icon}`}
                                alt={elem.icon}
                            />
                        </Tooltip>
                    </button>
                )
            })}
            
        </>
    )
    
  }

  const validateInput = (value:any,type:string)=>{
    switch(type){
        case 'trimesterNumber':
            // eslint-disable-next-line no-constant-condition
            if(true){
                return true;
            }else{
                return false;
            }
        case 'fhr':
            // eslint-disable-next-line no-constant-condition
            if(true){
                return true;
            }else{
                return false;
            }
        case 'bloodGroup':
            // eslint-disable-next-line no-constant-condition
            if(true){
                return true;
            }else{
                return false;
            }
        case 'vaccinationsComments':
            // eslint-disable-next-line no-constant-condition
            if(true){
                return true;
            }else{
                return false;
            }
        case 'vaccinations':
            // eslint-disable-next-line no-constant-condition
            if(true){
                return true;
            }else{
                return false;
            }
        case 'investigation':
            // eslint-disable-next-line no-constant-condition
            if(true){
                return true;
            }else{
                return false;
            }
        case 'investigationComments':
            // eslint-disable-next-line no-constant-condition
            if(true){
                return true;
            }else{
                return false;
            }
        case 'details':
            // eslint-disable-next-line no-constant-condition
            if(true){
                return true;
            }else{
                return false;
            }
        default:
            return false;
    }
  }

  const updateHistory = (event?:SyntheticEvent, value?: string | null, forKey?:string)=>{
    
    const target =
      (event?.target as HTMLInputElement) ||
      (event?.target as HTMLElement);

    const ariaLabel = target?.ariaLabel as string;
    const inputName = target?.name as string;

    const key = forKey || inputName;

    setTabData((prev: any) => {
        return prev.map((section: any) => {
          if (section.view_type === OBG_NOTES) {
            return {
              ...section,
              rows: section.rows.map((row: any) => {
                if (row.view_type === TRIMESTER_NOTES) {
                  return {
                    ...row,
                    value: row?.value?.map((val: any) => {
                      if (val?.name === key) {
                        return {
                          ...val,
                          value: value,
                        };
                      }
                      return val;
                    }),
                  };
                }
                return row;
              }),
            };
          }
          return section;
        });
      });
    return;
  }

  return (
    <>
      {loading && (
        <>
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </>
      )}
      {!loading && !isMobileScreen && (
        <Card
          styles={{
            boxShadow: `${isFocused ? CARD_SHADOW : "none"}`,
            position: "relative",
          }}
          title="Trimester Notes"
        >
          <CardHeader
            headerImg=""
            headerTitle="Trimester Notes"
          >
            <Box display={'flex'} gap={1}>
                {renderHeaderButtons()}
            </Box>
            
          </CardHeader>

          <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Box display={'flex'} sx={{width:'100%'}} gap={2}>
                <TextField
                    label={'Trimester Number'}
                    name='Trimester number'
                    value={state.trimesterNumber}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'trimesterNumber')){
                            setState({
                                trimesterNumber:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:1}}
                />
                <TextField
                    label={'FHR'}
                    name='FHR'
                    value={state.fhr}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'fhr')){
                            setState({
                                fhr:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:1}}
                />
                <TextField
                    label={'Blood group'}
                    name='Blood group'
                    value={state.bloodGroup}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'bloodGroup')){
                            setState({
                                bloodGroup:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:1}}
                />
            </Box>
            <Box display={'flex'} sx={{width:'100%'}} gap={2}>
                <FormControl  sx={{flex:1}}>
                    <InputLabel id="demo-simple-select-label">Vaccinations</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name='Vaccination'
                        value={state.vaccinations}
                        label="Vaccinations"
                        onChange={(e)=>{
                            if(validateInput(e.target.value,'vaccinations')){
                                setState({
                                    vaccinations:e.target.value
                                })
                            }
                        }}
                        onBlur={(event: any) => {
                            updateHistory(event, event.target.value);
                        }}
                    >
                        {state.vaccinationsOptions?.map((elem:any)=>{
                            return (
                                <MenuItem value={elem}>{elem}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                <TextField
                    label={'Comments'}
                    name='vaccination_comment'
                    value={state.vaccinationsComments}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'vaccinationsComments')){
                            setState({
                                vaccinationsComments:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:2}}
                />
            </Box>
            <Box display={'flex'} sx={{width:'100%'}} gap={2}>
                <FormControl sx={{flex:1}}>
                    <InputLabel id="demo-simple-select-label">Investigation</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name='Investigation'
                        value={state.investigation}
                        label="Investigation"
                        onChange={(e)=>{
                            if(validateInput(e.target.value,'investigation')){
                                setState({
                                    investigation:e.target.value
                                })
                            }
                        }}
                        onBlur={(event: any) => {
                            updateHistory(event, event.target.value);
                        }}
                    >
                        {state.investigationOptions?.map((elem:any)=>{
                            return (
                                <MenuItem value={elem}>{elem}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                <TextField
                    label={'Comments'}
                    name='investigation_comment'
                    value={state.investigationComments}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'investigationComments')){
                            setState({
                                investigationComments:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:2}}
                />
            </Box>
            <ReactQuill
                id="rx-examination-findings"
                theme="snow"
                placeholder="Enter details"
                modules={EditorModules}
                value={state.details}
                onChange={(content, _delta, _source, editor) => {
                    let newComment = content;
                    if (editor.getLength() <= 1) {
                        newComment = "";
                    }
                    if (editor.getLength() > 1500) {
                        newComment = newComment.substring(0, 1500);
                    }
                    setState({
                        details:newComment
                    })
                    // setTabData((prev: any) => {
                //     return prev.map((section: any) => {
                //     if (section.view_type === MENSTRUAL_HISTORY) {
                //         return {
                //         ...section,
                //         rows: section.rows.map((row: any, index: number) => {
                //             if (index === 0) {
                //             return {
                //                 ...row,
                //                 value: row.value.map((val: any, index: number) => {
                //                 if (index === 0) {
                //                     return {
                //                     ...val,
                //                     comments: newComment ? newComment : "",
                //                     };
                //                 }
                //                 return val;
                //                 }),
                //             };
                //             }
                //             return row;
                //         }),
                //         };
                //     }
                //     return section;
                //     });
                // });
                }}
                onBlur={(e:any)=>{
                    updateHistory(e,state.details,'comment');
                }}
                style={{ color: "#000000" }}
            />
          </Box>
          

          
        </Card>
      )}
      {!loading && isMobileScreen && (
        <>
          <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Box display={'flex'} width={'100%'} gap={2}>
                <TextField
                    label={'Trimester Number'}
                    name='Trimester number'
                    value={state.trimesterNumber}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'trimesterNumber')){
                            setState({
                                trimesterNumber:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:1}}
                />
                <TextField
                    label={'FHR'}
                    name='FHR'
                    value={state.fhr}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'fhr')){
                            setState({
                                fhr:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:1}}
                />
            </Box>
            <Box display={'flex'} width={'100%'} gap={2}>
                <TextField
                    label={'Blood group'}
                    name='Blood group'
                    value={state.bloodGroup}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'bloodGroup')){
                            setState({
                                bloodGroup:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:1}}
                />
                <Box sx={{flex:1}}></Box>
            </Box>
            <Box display={'flex'} flexDirection={'column'} width={'100%'} gap={2}>
                <FormControl  sx={{flex:1}}>
                    <InputLabel id="demo-simple-select-label">Vaccinations</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name='Vaccination'
                        value={state.vaccinations}
                        label="Vaccinations"
                        onChange={(e)=>{
                            if(validateInput(e.target.value,'vaccinations')){
                                setState({
                                    vaccinations:e.target.value
                                })
                            }
                        }}
                        onBlur={(event: any) => {
                            updateHistory(event, event.target.value);
                        }}
                    >
                        {state.vaccinationsOptions?.map((elem:any)=>{
                            return (
                                <MenuItem value={elem}>{elem}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                <TextField
                    label={'Comments'}
                    name='vaccination_comment'
                    value={state.vaccinationsComments}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'vaccinationsComments')){
                            setState({
                                vaccinationsComments:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:1}}
                />
            </Box>
            <Divider sx={{width:'100%'}}/>
            <Box display={'flex'} flexDirection={'column'} width={'100%'} gap={2}>
                <FormControl sx={{flex:1}}>
                    <InputLabel id="demo-simple-select-label">Investigation</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name='Investigation'
                        value={state.investigation}
                        label="Investigation"
                        onChange={(e)=>{
                            if(validateInput(e.target.value,'investigation')){
                                setState({
                                    investigation:e.target.value
                                })
                            }
                        }}
                        onBlur={(event: any) => {
                            updateHistory(event, event.target.value);
                        }}
                    >
                        {state.investigationOptions?.map((elem:any)=>{
                            return (
                                <MenuItem value={elem}>{elem}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                <TextField
                    label={'Comments'}
                    name='investigation_comment'
                    value={state.investigationComments}
                    onChange={(e)=>{
                        if(validateInput(e.target.value,'investigationComments')){
                            setState({
                                investigationComments:e.target.value
                            })
                        }
                    }}
                    onBlur={(event: any) => {
                        updateHistory(event, event.target.value);
                    }}
                    sx={{flex:2}}
                />
            </Box>
            <Divider sx={{width:'100%'}}/>
            <ReactQuill
                id="rx-examination-findings"
                theme="snow"
                placeholder="Enter details"
                modules={EditorModules}
                value={state.details}
                onChange={(content, _delta, _source, editor) => {
                    let newComment = content;
                    if (editor.getLength() <= 1) {
                        newComment = "";
                    }
                    if (editor.getLength() > 1500) {
                        newComment = newComment.substring(0, 1500);
                    }
                    setState({
                        details:newComment
                    })
                    // setTabData((prev: any) => {
                //     return prev.map((section: any) => {
                //     if (section.view_type === MENSTRUAL_HISTORY) {
                //         return {
                //         ...section,
                //         rows: section.rows.map((row: any, index: number) => {
                //             if (index === 0) {
                //             return {
                //                 ...row,
                //                 value: row.value.map((val: any, index: number) => {
                //                 if (index === 0) {
                //                     return {
                //                     ...val,
                //                     comments: newComment ? newComment : "",
                //                     };
                //                 }
                //                 return val;
                //                 }),
                //             };
                //             }
                //             return row;
                //         }),
                //         };
                //     }
                //     return section;
                //     });
                // });
                }}
                onBlur={(e:any)=>{
                    updateHistory(e,state.details,'comment');
                }}
                style={{ color: "#000000" }}
            />
          </Box>
        </>
      )}
    </>
  )
}

export default TrimesterNotes